import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {NOOP_FUNCTION} from "../../../../../stem-core/src/base/Utils";
import {isSmallScreen} from "../../../../UtilsLib";


class InlineUserDashboardSectionStyle extends StyleSheet {
    @styleRule
    inlineSection = {
        padding: "12px 0",
    };

    @styleRule
    separator = {
        ":not(:last-child)": {
            borderBottom: "0.5px solid #E5E5E5",
            paddingBottom: 24,
        }
    };

    @styleRule
    header = {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 8,
    };

    @styleRule
    title = {
        fontSize: isSmallScreen() ? this.themeProps.MERCHANT_FONT_SIZE_LARGE : 18,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    headerTitle = {
        fontSize: isSmallScreen() ? this.themeProps.MERCHANT_FONT_SIZE_LARGE : 18,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        textTransform: "uppercase",
        marginBottom: 8,
    };

    @styleRule
    action = this.themeProps.PANEL_LINK;
}

@registerStyle(InlineUserDashboardSectionStyle)
export class InlineUserDashboardSection extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            actionFunction: NOOP_FUNCTION,
            actionMessage: "",
            secondaryActionFunction: NOOP_FUNCTION,
            secondaryActionMessage: "",
            titleMessage: "",
            headerTitle: "",
            hideSeparator: false,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.inlineSection);
        if (!this.options.hideSeparator) {
            attr.addClass(this.styleSheet.separator);
        }
    }

    getChildrenToRender() {
        const {styleSheet} = this;
        const {titleMessage, headerTitle, actionMessage, actionFunction, secondaryActionMessage,
            secondaryActionFunction} = this.options;

        return [
            headerTitle && <div className={styleSheet.headerTitle}>{headerTitle}</div>,
            <div className={styleSheet.header}>
                {titleMessage && <div className={styleSheet.title}>{titleMessage}</div>}
                <div style={{flex: 1}} />
                {secondaryActionMessage && <div className={styleSheet.action} onClick={secondaryActionFunction} style={{marginRight: 12}}>{secondaryActionMessage}</div>}
                {actionMessage && <div className={styleSheet.action} onClick={actionFunction}>{actionMessage}</div>}
            </div>,
            this.render(),
        ];
    }
}
